import {
  sendCreatePartyRequest,
  sendGetPartyRequest,
} from "../../../api/votify.api";
import actions from "./partyActions";
import preferencesActions from "../../Preferences/preferencesActions";
import playbackActions from "../VotifyPlayback/playbackActions";
import { setPartyIdToStorage } from "../../../storage/storage";
import { handleRouteError } from "../../Util/utilActionCreators";
import { tabNames } from "../../../constants";

export const getAndGoToParty = (partyId, history) => {
  return async (dispatch) => {
    dispatch({ type: actions.START_GET_PARTY_REQUEST });
    const { ok, data: party, error } = await sendGetPartyRequest(partyId);
    console.log("getAndGoToParty");
    console.log(party);
    if (ok) {
      setPartyIdToStorage(partyId);
      dispatch({ type: actions.FOUND_PARTY, payload: party });
      dispatch({ type: actions.JOIN_PARTY, payload: party });
      if (party.creator.country) {
        dispatch({
          type: preferencesActions.SET_LOCALE,
          payload: party.creator.country,
        });
      }
      // Handling setting initalized in playback for now. Might make sense to do it in party reducer.
      if (party.isInitialized) {
        dispatch({
          type: playbackActions.SUCCESS_INITIALIZE_PLAYBACK,
        });
      }
      history.replace(`/p/${partyId}`);
    } else {
      dispatch({
        type: actions.NOT_FOUND_PARTY,
        payload: error,
      });
    }
    dispatch({ type: actions.END_GET_PARTY_REQUEST });
  };
};
export const getParty = (partyId) => {
  return async (dispatch) => {
    dispatch({ type: actions.START_GET_PARTY_REQUEST });
    const { ok, data: party, error } = await sendGetPartyRequest(partyId);
    console.log("getParty");
    console.log(party);
    if (ok) {
      setPartyIdToStorage(partyId);
      dispatch({ type: actions.FOUND_PARTY, payload: party });
      dispatch({ type: actions.JOIN_PARTY, payload: party });
      if (party.creator.country) {
        dispatch({
          type: preferencesActions.SET_LOCALE,
          payload: party.creator.country,
        });
      }
      // Handling setting initalized in playback for now. Might make sense to do it in party reducer.
      if (party.isInitialized) {
        dispatch({
          type: playbackActions.SUCCESS_INITIALIZE_PLAYBACK,
        });
      }
    } else {
      dispatch({
        type: actions.NOT_FOUND_PARTY,
        payload: error,
      });
    }
    dispatch({ type: actions.END_GET_PARTY_REQUEST });
  };
};

export const createAndGoToParty = (history) => {
  return async (dispatch, getState) => {
    dispatch({ type: actions.START_CREATE_PARTY_REQUEST });
    const { ok, data: party, error } = await sendCreatePartyRequest(
      getState().host.jwtToken,
    );
    console.log("createAndGoToParty");
    console.log(party);
    if (ok) {
      setPartyIdToStorage(party.id);
      dispatch({
        type: actions.CREATE_PARTY,
        payload: party,
      });
      dispatch({ type: actions.FOUND_PARTY, payload: party });
      dispatch({ type: actions.JOIN_PARTY, payload: party });
      if (party.creator.country) {
        dispatch({
          type: preferencesActions.SET_LOCALE,
          payload: party.creator.country,
        });
      }
      // Handling setting initalized in playback for now. Might make sense to do it in party reducer.
      if (party.isInitialized) {
        dispatch({
          type: playbackActions.SUCCESS_INITIALIZE_PLAYBACK,
        });
      }
      history.replace(`/p/${party.id}?tab=${tabNames.SETTINGS}`);
    } else {
      dispatch({
        type: actions.NOT_CREATE_PARTY,
        payload: error,
      });
      console.error("Could not create party");
      dispatch(handleRouteError(history));
    }
    dispatch({ type: actions.END_CREATE_PARTY_REQUEST });
  };
};

export const handleLeaveParty = (message) => {
  return {
    type: actions.LEAVE_PARTY,
    payload: { ...message },
  };
};

export const handleLoadParty = (party) => {
  return { type: actions.LOAD_PARTY, payload: { party } };
};
